export default "__VITE_ASSET__BpTgAIKf__"